import { FunctionComponent } from 'react';
import { Button, ButtonGroup, Modal, Text } from '@nike/eds';

const DeleteConfirmModal: FunctionComponent<any> = ({
  onDelete,
  isOpen,
  onDismiss,
}) => (
  <Modal
    onDismiss={onDismiss}
    isOpen={isOpen}
    headerSlot={<>Are you sure?</>}
    footerSlot={
      <ButtonGroup>
        <Button onClick={onDelete} size="small">
          Delete
        </Button>
        <Button onClick={onDismiss} size="small" variant="secondary">
          Close
        </Button>
      </ButtonGroup>
    }
  >
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
      }}
    >
      <Text font="body-1" as="p">
        Are you sure you want to delete this transfer?
      </Text>
    </div>
  </Modal>
);

export default DeleteConfirmModal;
